module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "catalog-list",
    class: {
      "catalog-list_recommended": _vm.usePadding, "catalog-list_hidden": !_vm.visible
    }
  }, [(_vm.$slots.title || _vm.title) ? _c('div', {
    staticClass: "catalog-list__title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), (_vm.$slots.before) ? _c('div', {
    staticClass: "catalog-list__before"
  }, [_c('div', {
    staticClass: "catalog-list__before-outer"
  }, [_vm._t("before")], 2)]) : _vm._e(), _c('ul', {
    staticClass: "catalog-list__list"
  }, [(_vm.$slots.prefix) ? _c('li', {
    staticClass: "catalog-list__item"
  }, [_c('div', {
    staticClass: "catalog-list__item-inner"
  }, [_vm._t("prefix")], 2)]) : _vm._e(), _vm._l((_vm.listItems), function(item, index) {
    return _c('OrganizationSingleItem', {
      key: index,
      attrs: {
        "item": item,
        "constrain-name-height": _vm.constrainNameHeight
      },
      on: {
        "delete": _vm.onDelete,
        "cancel": function (index) {
          _vm.$emit("cancel", index);
        },
        "contracts": function($event) {
          return _vm.$emit("contracts", $event)
        }
      }
    })
  }), _vm._l((3), function(key) {
    return _c('li', {
      key: ("tail-" + key),
      staticClass: "catalog-list__item catalog-list__item_blank"
    })
  })], 2), (_vm.hasAfterSlot) ? _c('div', {
    staticClass: "catalog-list__after"
  }, [_c('div', {
    staticClass: "catalog-list__after-left"
  }, [_vm._t("left")], 2), _c('div', {
    staticClass: "catalog-list__after-center"
  }, [_vm._t("after")], 2), _c('div', {
    staticClass: "catalog-list__after-right"
  }, [_vm._t("right")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b5f79a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/component.vue
// module id = a3e357e94467c7610a27
// module chunks = 89